/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Top navigation menu toggle is implemented in top-navigation.js */


/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Keywords navigation bar horizontal scroll */
(function () {
    const keywordsScroll = document.querySelector('.gh-keywords-scroll');
    if (!keywordsScroll) return;

    // Enable smooth scrolling with mouse wheel
    keywordsScroll.addEventListener('wheel', function(e) {
        if (e.deltaY === 0) return;
        e.preventDefault();
        keywordsScroll.scrollLeft += e.deltaY;
    });

    // Enable touch scrolling for mobile
    let isDown = false;
    let startX;
    let scrollLeft;

    keywordsScroll.addEventListener('mousedown', function(e) {
        isDown = true;
        startX = e.pageX - keywordsScroll.offsetLeft;
        scrollLeft = keywordsScroll.scrollLeft;
    });

    keywordsScroll.addEventListener('mouseleave', function() {
        isDown = false;
    });

    keywordsScroll.addEventListener('mouseup', function() {
        isDown = false;
    });

    keywordsScroll.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - keywordsScroll.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        keywordsScroll.scrollLeft = scrollLeft - walk;
    });

    // Safari-specific touch handling
    keywordsScroll.addEventListener('touchstart', function(e) {
        startX = e.touches[0].pageX - keywordsScroll.offsetLeft;
        scrollLeft = keywordsScroll.scrollLeft;
    });

    keywordsScroll.addEventListener('touchmove', function(e) {
        const x = e.touches[0].pageX - keywordsScroll.offsetLeft;
        const walk = (x - startX) * 2;
        keywordsScroll.scrollLeft = scrollLeft - walk;
    });

    // Force horizontal scrolling to work in Safari
    const keywordsBar = document.querySelector('.gh-keywords-bar');
    if (keywordsBar) {
        keywordsBar.style.webkitOverflowScrolling = 'touch';
        keywordsBar.style.overflowX = 'auto';
    }

    // Handle window resize to ensure scrolling works when screen width changes
    window.addEventListener('resize', function() {
        // Force a reflow of the keywords bar to ensure proper scrolling
        keywordsScroll.style.overflow = 'hidden';
        setTimeout(function() {
            keywordsScroll.style.overflow = 'auto';
            // Ensure parent container also allows horizontal scrolling
            document.querySelector('.gh-keywords-bar').style.overflowX = 'auto';
            }, 0);
        });
        })();
        
        /* --- Custom Auth Logic --- */
        (function() {
            function initCustomAuth() {
                const token = localStorage.getItem('auth_token');
                const userJson = localStorage.getItem('user');
                
                const signinLink = document.getElementById('auth-signin-link');
                const userMenu = document.getElementById('auth-user-menu');
                const userNameSpan = document.getElementById('auth-user-name');
                const logoutLink = document.getElementById('auth-logout-link');
                const userMenuBtn = document.getElementById('user-menu-button');
                const userDropdown = document.getElementById('user-dropdown-content');
        
                if (token && userJson) {
                    try {
                        const user = JSON.parse(userJson);
                        if (signinLink) signinLink.style.display = 'none';
                        if (userMenu) userMenu.style.display = 'block';
                        if (userNameSpan) userNameSpan.textContent = user.username || 'User';
                    } catch (e) {
                        console.error('Error parsing user data', e);
                    }
                }
        
                if (logoutLink) {
                    logoutLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        localStorage.removeItem('auth_token');
                        localStorage.removeItem('user');
                        window.location.reload();
                    });
                }
        
                if (userMenuBtn && userDropdown) {
                    userMenuBtn.addEventListener('click', (e) => {
                        e.stopPropagation();
                        userDropdown.classList.toggle('active');
                    });
                    
                    // Close dropdown when clicking outside
                    window.addEventListener('click', (e) => {
                        if (!userMenuBtn.contains(e.target) && !userDropdown.contains(e.target)) {
                            userDropdown.classList.remove('active');
                        }
                    });
                }
            }
        
            // Wait for DOM to be ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initCustomAuth);
            } else {
                initCustomAuth();
            }
        })();